module.exports = __webpack_public_path__ + "img/canem-logo.c0fccda0.svg";